<template>
  <div>
    <div class="font-weight-bold text-cello">Direction</div>
    <div class="mt-2 shadow-sm p-2 bg-white rounded">
      <el-radio-group
        v-model="direction_id"
        @change="$emit('directionId', direction_id)"
      >
        <el-radio
          class="w-100"
          v-for="item in directions"
          :key="item.id"
          :label="item.id"
        >
          {{ item.name }}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clearChild: {
      type: Number,
    },
  },
  data() {
    return {
      directions: [
        { id: 2, name: "Payout" },
        { id: 1, name: "Refinance" },
      ],
      direction_id: null,
    };
  },
  watch: {
    clearChild: function (newVal, oldVal) {
      this.clear();
    },
  },
  created() {},
  mounted() {},
  methods: {
    clear() {
      this.direction_id = null;
    },
  },
};
</script>
